<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  {{data.description}}
  <br><br>
  <button mat-button matDialogClose="no" (click)="onNoClick()" data-testid='btn_close'>{{'loginuser_button_close' | translate }}</button>
</div>